import type { embedSearchWidgetViewVolopRoute } from 'modules/embedSearchWidget/routing/embedSearchWidget.routes';
import type { HorizonAppRouteLoaderArgs } from 'routing/classes/types/AppRouteLoaderArgs';
import type { HorizonAppRouteComponentProps } from 'routing/types/HorizonAppRouteComponentProps';

import { EmbedSearchWidgetApplyToVolopPageLoadable } from './EmbedSearchWidgetApplyToVolopPageLoadable';

export async function loader(
  _: HorizonAppRouteLoaderArgs<typeof embedSearchWidgetViewVolopRoute>,
) {
  await EmbedSearchWidgetApplyToVolopPageLoadable.load();
}

export default function EmbedSearchWidgetApplyToVolopHorizonRoute(
  _: HorizonAppRouteComponentProps<typeof loader>,
) {
  return <EmbedSearchWidgetApplyToVolopPageLoadable />;
}
